"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UssImgUploader = exports.UssImg = void 0;
var utils_1 = require("./utils");
var axios_1 = require("axios");
var ImgUploadUtils_1 = require("./ImgUploadUtils");
var package_json_1 = require("../package.json");
var report_1 = require("./report");
var etag_1 = require("./etag");
var types_1 = require("./types");
var UssImg = /** @class */ (function () {
    function UssImg(option) {
        this.option = option;
        if (!option.skipReport) {
            this.report = new report_1.Report({
                country: this.option.country,
                biz: this.option.biz,
                env: this.option.env,
                sdkVersion: 'uss-' + package_json_1.version,
                uid: option.uid,
                reportNoLimit: true
            });
        }
        this.imgUploadUtil = new ImgUploadUtils_1.ImgUploadUtil({
            report: this.report,
            biz: this.option.biz,
            env: this.option.env,
            country: this.option.country,
            uid: option.uid
        });
    }
    UssImg.prototype.upload = function (imgFiles) {
        return __awaiter(this, void 0, void 0, function () {
            var strategy;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!imgFiles.length || imgFiles.length > 9) {
                            return [2 /*return*/, Promise.reject(new Error('image count too many or too little'))];
                        }
                        return [4 /*yield*/, this.imgUploadUtil.getStrategy('uss_image_strategy')];
                    case 1:
                        strategy = _a.sent();
                        return [2 /*return*/, new UssImgUploader({
                                imgFiles: imgFiles,
                                strategy: strategy,
                                report: this.report,
                                imgUploadUtil: this.imgUploadUtil,
                                biz: this.option.biz
                            })];
                }
            });
        });
    };
    return UssImg;
}());
exports.UssImg = UssImg;
var UssImgUploader = /** @class */ (function () {
    function UssImgUploader(options) {
        this.options = options;
        this.curImgIdx = 0;
        this.canceled = false;
        this.curServiceId = 'shopeeuss';
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.eventMap = new Map();
        this.cancelToken = axios_1.default.CancelToken.source();
        this.doneResult = [];
        this.$chore = axios_1.default.create({
            timeout: this.strategy.api_timeout,
            adapter: utils_1.retryAdapterEnhancer(axios_1.default.defaults.adapter, {
                times: this.strategy.retry_count,
                delay: this.strategy.backoff_time
            })
        });
        this.$upload = axios_1.default.create({
            adapter: utils_1.retryAdapterEnhancer(axios_1.default.defaults.adapter, {
                times: this.strategy.retry_count,
                delay: this.strategy.backoff_time
            })
        });
    }
    UssImgUploader.prototype.done = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var _e, startTime, fileTransferEventCommon, data, error_1, actionId, error_2;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 9, 10, 11]);
                        _e = this;
                        return [4 /*yield*/, this.options.imgUploadUtil.preupload({
                                axiosInstance: this.$chore,
                                imgCount: this.options.imgFiles.length || this.strategy.default_img_count,
                                strategyVer: this.strategy.ver
                            })];
                    case 1:
                        _e.uploadMsg = _f.sent();
                        _f.label = 2;
                    case 2:
                        if (!(this.curImgIdx < this.options.imgFiles.length &&
                            this.curImgIdx < this.imgIds.length &&
                            !this.canceled)) return [3 /*break*/, 8];
                        startTime = Date.now();
                        fileTransferEventCommon = {
                            serviceId: this.curServiceId,
                            serviceIdx: this.curUploadMsg.index,
                            imgid: this.imgIds[this.curImgIdx],
                            strategyVer: this.strategy.ver
                        };
                        _f.label = 3;
                    case 3:
                        _f.trys.push([3, 6, , 7]);
                        return [4 /*yield*/, this.putObject({
                                file: this.options.imgFiles[this.curImgIdx],
                                onUploadProgress: function (event) {
                                    _this.emit(types_1.UploaderEvents.imageProgress, __assign(__assign({}, event), { index: _this.curImgIdx }));
                                },
                                cancelToken: this.cancelToken
                            })];
                    case 4:
                        data = _f.sent();
                        this.doneResult.push(data);
                        this.emit(types_1.UploaderEvents.imageUpload, data);
                        return [4 /*yield*/, this.options.imgUploadUtil.notify({
                                axiosInstance: this.$chore,
                                serviceId: this.curServiceId,
                                imgId: this.imgIds[this.curImgIdx],
                                url: data.url,
                                fsize: this.options.imgFiles[this.curImgIdx].size,
                                finishTime: Math.trunc(Date.now() / 1000),
                                token: this.curUploadMsg.token,
                                strategyVer: this.strategy.ver
                            })];
                    case 5:
                        _f.sent();
                        (_a = this.options.report) === null || _a === void 0 ? void 0 : _a.ImgFileTransferEvent(__assign(__assign({}, fileTransferEventCommon), { actionId: 0, code: 0, extendId: this.imgIds[this.curImgIdx], fsize: this.options.imgFiles[this.curImgIdx].size, cost: Date.now() - startTime }));
                        this.curImgIdx++;
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _f.sent();
                        actionId = 4001;
                        if (axios_1.default.isCancel(error_1))
                            actionId = 4003;
                        (_b = this.options.report) === null || _b === void 0 ? void 0 : _b.ImgFileTransferEvent(__assign(__assign({}, fileTransferEventCommon), { actionId: actionId, code: ((_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _c === void 0 ? void 0 : _c.data.code) || -1, cost: Date.now() - startTime }));
                        throw error_1;
                    case 7: return [3 /*break*/, 2];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        error_2 = _f.sent();
                        this.cancel();
                        throw error_2;
                    case 10:
                        (_d = this.options.report) === null || _d === void 0 ? void 0 : _d.report();
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/, this.doneResult];
                }
            });
        });
    };
    UssImgUploader.prototype.putObject = function (_a) {
        var file = _a.file, onUploadProgress = _a.onUploadProgress, cancelToken = _a.cancelToken;
        return __awaiter(this, void 0, void 0, function () {
            var etag, etagSlices, toBeUploadedSlices, shouldSlice, index, start, end, size, slice, _b, _c, tasks, queue;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        etagSlices = [];
                        toBeUploadedSlices = [];
                        shouldSlice = file.size > this.strategy.slice;
                        if (!!shouldSlice) return [3 /*break*/, 2];
                        return [4 /*yield*/, etag_1.getEtag(file)];
                    case 1:
                        etag = _d.sent();
                        _d.label = 2;
                    case 2:
                        index = 0;
                        _d.label = 3;
                    case 3:
                        if (!(index < file.size / this.strategy.slice)) return [3 /*break*/, 6];
                        start = this.strategy.slice * index;
                        end = start + this.strategy.slice;
                        size = (end <= file.size ? end : file.size) - start;
                        slice = file.slice(start, start + size);
                        _c = (_b = etagSlices).push;
                        return [4 /*yield*/, etag_1.getEtag(slice)];
                    case 4:
                        _c.apply(_b, [_d.sent()]);
                        toBeUploadedSlices.push({ index: index, slice: slice, size: size });
                        _d.label = 5;
                    case 5:
                        index++;
                        return [3 /*break*/, 3];
                    case 6:
                        tasks = toBeUploadedSlices.map(function (_a) {
                            var slice = _a.slice, size = _a.size, index = _a.index;
                            return function () { return __awaiter(_this, void 0, void 0, function () {
                                var headers;
                                return __generator(this, function (_a) {
                                    headers = {
                                        Authorization: this.curUploadMsg.token,
                                        Etag: shouldSlice ? etagSlices[index] : etag,
                                        'X-Request-Id': shouldSlice
                                            ? this.imgIds[this.curImgIdx] + "-" + (index + 1)
                                            : this.imgIds[this.curImgIdx] + "-0",
                                        'Content-Type': shouldSlice
                                            ? types_1.ContentTypeHeader.slice
                                            : types_1.ContentTypeHeader.image
                                    };
                                    if (shouldSlice) {
                                        Object.assign(headers, {
                                            'X-Slice-Index': index + 1
                                        });
                                    }
                                    return [2 /*return*/, this.$upload
                                            .post(this.curUploadMsg.upload_domain + "/api/v3/" + this.curUploadMsg.bucket + "/" + this.imgIds[this.curImgIdx], slice, {
                                            cancelToken: cancelToken.token,
                                            headers: headers
                                        })
                                            .then(function () { return ({
                                            size: size,
                                            index: index
                                        }); })];
                                });
                            }); };
                        });
                        queue = new utils_1.Queue(tasks, { concurrency: this.strategy.concurrency });
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var fulfilled = 0;
                                queue.setTaskFullfilledHandler(function (_a) {
                                    var size = _a.size, index = _a.index;
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var loaded, data, error_3;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    loaded = index * this.strategy.slice + size;
                                                    onUploadProgress === null || onUploadProgress === void 0 ? void 0 : onUploadProgress({
                                                        total: file.size,
                                                        loaded: loaded,
                                                        percent: parseFloat((loaded / file.size).toFixed(2))
                                                    });
                                                    if (tasks.length === 1) {
                                                        resolve({
                                                            index: this.curImgIdx,
                                                            etag: etag,
                                                            url: this.getFileUrl(),
                                                            img_id: this.imgIds[this.curImgIdx]
                                                        });
                                                        return [2 /*return*/];
                                                    }
                                                    if (!(++fulfilled === tasks.length)) return [3 /*break*/, 4];
                                                    _b.label = 1;
                                                case 1:
                                                    _b.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, this.mergeObject(etagSlices, cancelToken)];
                                                case 2:
                                                    data = _b.sent();
                                                    resolve(data);
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    error_3 = _b.sent();
                                                    reject(error_3);
                                                    return [3 /*break*/, 4];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    });
                                });
                                queue.setAllTaskFullfilledHandler(function () { });
                                queue.setTaskRejectedHandler(function (error) {
                                    _this.cancel();
                                    reject(error);
                                });
                                queue.start();
                            })];
                }
            });
        });
    };
    UssImgUploader.prototype.mergeObject = function (etagSlices, cancelToken) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data, _a, _b, _c;
            var _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        params = {
                            merge_etag: etagSlices.map(function (item, idx) { return ({
                                index: idx + 1,
                                etag: item
                            }); })
                        };
                        _b = (_a = this.$upload).post;
                        _c = [this.curUploadMsg.upload_domain + "/api/v3/merge/" + this.curUploadMsg.bucket + "/" + this.imgIds[this.curImgIdx], params];
                        _d = {};
                        _e = {
                            'X-Request-Id': this.imgIds[this.curImgIdx] + '-merge',
                            'Content-Type': types_1.ContentTypeHeader.image,
                            Authorization: this.curUploadMsg.token,
                            'X-Merge-Total': etagSlices.length
                        };
                        return [4 /*yield*/, etag_1.getEtag(new Blob([JSON.stringify(params)]))];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([(_d.headers = (_e.Etag = _f.sent(),
                                _e),
                                _d.cancelToken = cancelToken.token,
                                _d)]))];
                    case 2:
                        data = (_f.sent()).data.data;
                        return [2 /*return*/, {
                                index: this.curImgIdx,
                                url: this.getFileUrl(),
                                etag: data.etag,
                                img_id: this.imgIds[this.curImgIdx]
                            }];
                }
            });
        });
    };
    UssImgUploader.prototype.getFileUrl = function () {
        return this.curUploadMsg.play_domain + '/' + this.imgIds[this.curImgIdx];
    };
    UssImgUploader.prototype.cancel = function () {
        this.cancelToken.cancel();
        this.canceled = true;
    };
    Object.defineProperty(UssImgUploader.prototype, "strategy", {
        get: function () {
            return __assign({ ver: this.options.strategy.ver, api_timeout: this.options.strategy.api_timeout }, (this.options.strategy.configs[this.options.biz] ||
                this.options.strategy.configs[100]).upload);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UssImgUploader.prototype, "curUploadMsg", {
        get: function () {
            var _this = this;
            var result = this.uploadMsg.services.filter(function (item) { return item.service_id === _this.curServiceId; })[0];
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UssImgUploader.prototype, "imgIds", {
        get: function () {
            return this.uploadMsg.img_ids;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/ban-types
    UssImgUploader.prototype.on = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName) || new Set();
        callbacks.add(callback);
        this.eventMap.set(eventName, callbacks);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    UssImgUploader.prototype.off = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.delete(callback);
            if (callbacks.size === 0) {
                this.eventMap.delete(eventName);
            }
        }
    };
    UssImgUploader.prototype.emit = function (eventName, params) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.forEach(function (callback) {
                callback(params);
            });
        }
    };
    return UssImgUploader;
}());
exports.UssImgUploader = UssImgUploader;
